import { useTranslation } from 'react-i18next';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { SalesInvoice } from '../../../../interfaces/Sales/Invoices/salesinvoices';
import { TextField } from '@mui/material';
import { FormsErrors } from '../../../../hooks/Forms/FormsErrors';

type AnnotationsSalesInvoice = {
    control: Control<SalesInvoice>,
    errors: FieldErrors<SalesInvoice>,
    isEdit?: boolean,
}

export const AnnotationsSalesInvoice = ({
    control,
    errors,
    isEdit,
}: AnnotationsSalesInvoice) => {
    const { GetError } = FormsErrors();
    const [t] = useTranslation("global");

    return (
        <>
            <div className='w-100'>
                <Controller
                    name="notes"
                    control={control}
                    rules={{}}
                    render={({ field }) => (
                        <TextField
                            variant="filled"
                            label={`${t("salesinvoices.fields.notes")}`}
                            ref={field.ref}
                            value={field.value}
                            multiline
                            minRows={5}
                            onChange={(event) => { field.onChange(event.target.value) }}
                            error={!!errors.notes}
                            helperText={GetError(errors.notes?.type)}
                            size="small"
                            sx={{ width: "100%", paddingRight: 2 }}
                            disabled={isEdit}
                        />
                    )}
                />
            </div>
        </>
    )
}